export const FETCH_PERIODS = 'FETCH_PERIODS';
export const FETCH_PERIODS_SUCCESS = 'FETCH_PERIODS_SUCCESS';
export const FETCH_PERIODS_ERROR = 'FETCH_PERIODS_ERROR';
